export const getDisplayStatusClass = (displayStatus) => {
  if (!displayStatus) {
    return undefined;
  }

  const split = displayStatus.split(' ');

  return split[0].toLowerCase();
};
